module.exports = __webpack_public_path__ + "img/ascores.9fbfc9f3.png";